module.exports = __webpack_public_path__ + "static/media/DATALIFE-LOGO-INFO@2x.d6bc5e44.png";